import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image
} from "@react-pdf/renderer";
import fontBold from "./fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "./fonts/NotoSansTamil-Regular.ttf";

// Register Tamil fonts
Font.register({
  family: "fontBold",
  src: fontBold,
});
Font.register({
  family: "fontRegular",
  src: fontRegular,
});

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}.${month}.${year}`;
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: "#fff",
    fontFamily: "fontRegular",
  },
  container: {
    borderWidth: 1.5,
    borderColor: "#000",
    padding: 15,
    flexDirection: "column",
    position: "relative",
    minHeight: 740,
  },
  sideTextContainer: {
    position: "absolute",
    left: -140,
    top: 300,
    width: 350,
    transform: "rotate(-90deg)",
  },
  sideText: {
    fontSize: 8.5,
    fontFamily: "fontBold",
    lineHeight: 1.4,
    textAlign: "center",
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 5,
  },
  formName: {
    fontSize: 9,
  },
  rsBox: {
    borderWidth: 1.5,
    borderColor: "#000",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 3,
    minWidth: 110,
  },
  rsLabel: {
    fontSize: 11,
    fontFamily: "fontBold",
  },
  rsValue: {
    fontSize: 16,
    fontFamily: "fontBold",
    marginLeft: 10,
  },
  invocations: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 3,
  },
  storeName: {
    fontSize: 26,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 10,
  },
  subHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 10,
  },
  pawnNoContainer: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: 12,
  },
  pawnNoBox: {
    borderWidth: 1,
    borderColor: "#000",
    paddingHorizontal: 8,
    marginHorizontal: 4,
    minWidth: 30,
    textAlign: "center",
    height: 20,
    justifyContent: "center",
  },
  pawnTicketBox: {
    backgroundColor: "#000",
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: 3,
  },
  pawnTicketText: {
    color: "#fff",
    fontSize: 14,
    fontFamily: "fontBold",
  },
  ownerInfo: {
    fontSize: 10,
    textAlign: "right",
    width: "45%",
    lineHeight: 1.4,
  },
  licenseRow: {
    fontSize: 11,
    marginBottom: 5,
  },
  statement: {
    fontSize: 12,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 15,
    textDecoration: "underline",
  },
  table: {
    borderWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 40,
  },
  rowSno: {
    width: "8%",
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 8,
    fontSize: 11,
    textAlign: "center",
    justifyContent: "center",
  },
  rowLabel: {
    width: "44%",
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 8,
    fontSize: 11,
    justifyContent: "center",
  },
  rowValue: {
    width: "48%",
    padding: 8,
    fontSize: 12,
    fontFamily: "fontBold",
    justifyContent: "center",
  },
  phoneRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: 5,
  },
  phoneLabel: {
    fontSize: 9,
    marginRight: 10,
  },
  rowHeight5: {
    minHeight: 60,
  },
  weightContainer: {
    flexDirection: "column",
    marginTop: 5,
  },
  weightLine: {
    flexDirection: "row",
    alignItems: "baseline",
    fontSize: 11,
  },
  dots: {
    borderBottomWidth: 1,
    borderStyle: "dotted",
    flex: 1,
    marginHorizontal: 5,
  },
  footer: {
    marginTop: 10,
  },
  // Page 2 Styles
  page2Container: {
    padding: 10,
    alignItems: "center",
  },
  topText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 15,
    marginTop: 10,
  },
  businessHoursBox: {
    borderWidth: 1.2,
    borderColor: "#000",
    borderRadius: 8,
    padding: 10,
    width: "85%",
    marginBottom: 20,
    alignItems: "center",
  },
  businessHoursTitle: {
    fontSize: 13,
    fontFamily: "fontBold",
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: 8,
  },
  businessHoursText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    lineHeight: 1.4,
  },
  conditionsHeader: {
    backgroundColor: "#333",
    borderRadius: 12,
    paddingHorizontal: 25,
    paddingVertical: 4,
    marginBottom: 15,
  },
  conditionsHeaderText: {
    color: "#fff",
    fontSize: 13,
    fontFamily: "fontBold",
  },
  conditionsList: {
    width: "100%",
    paddingHorizontal: 5,
  },
  conditionRow: {
    flexDirection: "row",
    marginBottom: 7,
    lineHeight: 1.4,
  },
  conditionNumber: {
    fontSize: 10,
    fontFamily: "fontBold",
    width: 20,
  },
  conditionText: {
    fontSize: 10,
    fontFamily: "fontBold",
    flex: 1,
    textAlign: "justify",
  },
  bottomText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    marginTop: 20,
  },
  footerText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 5,
  },
  signatureRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 40,
    width: "100%",
    paddingHorizontal: 10,
  },
  signatureText: {
    fontSize: 11,
    fontFamily: "fontBold",
  },
  // Image styles
  imageContainer: {
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    width: "100%",
    marginTop: 10,
  },
  imageRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 5,
  },
  imageWrapper: {
    width: "45%",
    height: 120,
    marginHorizontal: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  proofImage: {
    width: 120,
    height: 120,
    objectFit: "contain",
  },
  emptyImagePlaceholder: {
    width: 120,
    height: 120,
    borderWidth: 1,
    borderColor: "#ccc",
    backgroundColor: "#f9f9f9",
  },
});

const JewelInterestPdf = ({ data }) => {
  if (!data) return null;

  // Split receipt number if possible (e.g., E 9101)
  const receiptNo = data.receipt_no || "";
  const prefix = receiptNo.charAt(0);
  const number = receiptNo.substring(1);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.container}>
          {/* Vertical Side Text */}


          {/* Header Section with Images */}
          <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            {/* Left: Jewel Image 1 */}
            {/* <View style={{ width: 80, height: 80, borderWidth: 1, borderColor: "#000", justifyContent: "center", alignItems: "center" }}>
              {data.proof && data.proof.length > 0 && data.proof[0] ? (
                <Image src={data.proof[0]} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              ) : (
                <Text style={{ fontSize: 9 }}>Jewel 1</Text>
              )}
            </View> */}

            {/* Center: Invocations & Store Name */}
            <View style={{ flex: 1, alignItems: "center", paddingHorizontal: 10 }}>
              <Text style={styles.invocations}>
                {data.shop_invocation1 || "ஸ்ரீ கப்பலூர் காளி துணை"}
              </Text>
              <Text style={styles.invocations}>
                {data.shop_invocation2 || "ஆதிகாமாட்சியம்மன் துணை"}
              </Text>
              <Text style={[styles.storeName, { marginTop: 5, marginBottom: 0 }]}>
                {data.shop_name || "ஸ்ரீ விக்னேஷ்வரா பைனான்ஸ்"}
              </Text>
            </View>

            {/* Right: Jewel Image 2 */}
            {/* <View style={{ width: 80, height: 80, borderWidth: 1, borderColor: "#000", justifyContent: "center", alignItems: "center" }}>
              {data.proof && data.proof.length > 1 && data.proof[1] ? (
                <Image src={data.proof[1]} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              ) : (
                <Text style={{ fontSize: 9 }}>Jewel 2</Text>
              )}
            </View> */}
          </View>

          <View style={styles.subHeader}>
            <View style={styles.pawnNoContainer}>
              <Text>அடகு No.</Text>
              <View style={[styles.pawnNoBox, { minWidth: 60 }]}>
                <Text>{receiptNo}</Text>
              </View>
            </View>
            <View style={styles.pawnTicketBox}>
              <Text style={styles.pawnTicketText}>வட்டி வரவு ரசீது</Text>
            </View>
            {/* <View style={styles.ownerInfo}>
              <Text style={{ fontFamily: "fontBold" }}>{data.shop_owner_name || ""}</Text>
              <Text>{data.shop_address || ""}</Text>
              <Text>{data.shop_place || ""}</Text>
            </View> */}
          </View>
          <Text style={styles.licenseRow}>அடகு வைத்{""}துக் கொண்டு கடன் கொடுப்பவரின் பெயர்:  {data.shop_license_no || "V.விஜயா"}</Text>
          <Text style={styles.licenseRow}>மற்றும் விலாசம் : {data.shop_license_no || "1/52/1, விநாயகர் கோவில் தெரு, கப்பலூர், திருமங்கலம் TK."}</Text>
          <Text style={styles.licenseRow}>லைசென்{""}ஸ் நம்பரும், தேதியும் : {data.shop_license_no || "4/96-97"}</Text>
          <Text style={styles.statement}>அடியிற்கண்{""}ட சொத்{""}துக்{""}கள் என்னிடம் அடகு வைக்கப்பட்{""}டுள்ளன.</Text>

          {/* Main Table */}
          <View style={styles.table}>
            {/* Row 1: Name & Address */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>1.</Text>
              </View>
              <View style={[styles.rowLabel, { justifyContent: "space-between" }]}>
                <View>
                  <Text>அடகு வைப்{""}பவர் பெயரு{""}ம் பூரண விலாசமு{""}ம்</Text>
                </View>
                <View style={{ alignItems: "flex-end", marginTop: 10 }}>
                  <Text style={{ fontSize: 11, marginRight: 5 }}>போ{""}ன் ந{""}ம்{""}ப{""}ர்</Text>
                </View>
              </View>
              <View style={[styles.rowValue, { justifyContent: "space-between" }]}>
                <View>
                  <Text style={{ fontSize: 12, fontFamily: "fontBold" }}>{data.customer_details || ""}</Text>
                  <Text style={{ fontSize: 10, marginTop: 5, fontFamily: "fontRegular" }}>
                    {data.palce || ""}
                  </Text>
                </View>
                <View style={{ marginTop: 10 }}>
                  <Text style={{ fontSize: 12, fontFamily: "fontBold" }}>
                    {data.mobile_number || ""}
                  </Text>
                </View>
              </View>
            </View>

            {/* Row 2: Date */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>2.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>தேதி</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{formatDate(data.interest_receive_date)}</Text>
              </View>
            </View>

            {/* Row 3: Principal Amount */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>3.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>வட்{""}டி தொகை.</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>ரூபாய் {data.outstanding_amount || ""}</Text>
              </View>
            </View>

            {/* Row 4: Interest Paid */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>4.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>வட்{""}டி தொகை வரவு </Text>
              </View>
              <View style={styles.rowValue}>
                <Text>ரூபாய் {data.interest_income || ""}</Text>
              </View>
            </View>

            {/* Row 5: Outstanding Period */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>5.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>நிலுவை காலம்</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{data.outstanding_period || ""}</Text>
              </View>
            </View>

            {/* Row 6: Interest Payment Period */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>6.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>வட்{""}டி வரவு காலம்</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{data.interest_payment_periods || ""}</Text>
              </View>
            </View>

            {/* Row 7: Payer Signature */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>7.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>வட்{""}டி செலுத்{""}தியவரி{""}ன் கையொப்{""}ப{""}ம்</Text>
              </View>
              <View style={styles.rowValue} />
            </View>

            {/* Row 8: Receiver Signature */}
            <View style={[styles.tableRow, { borderBottomWidth: 0 }]}>
              <View style={styles.rowSno}>
                <Text>8.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>பண{""}ம் பெற்{""}றுக்{""}கொண்{""}டவரி{""}ன் கையொப்{""}ப{""}ம்</Text>
              </View>
              <View style={styles.rowValue} />
            </View>
          </View>



        </View>
      </Page>
    </Document>
  );
};

export default JewelInterestPdf;
